import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Button, Layout, notification, PageHeader, Popconfirm, Row, Space, Table, Tooltip } from "antd";
import React, { Fragment } from "react";
import { useNavigate, useParams } from "react-router";

const articleItemQuery = gql`
  query ($id: ID!) {
    articleItem(id: $id) {
      id
      prices {
        id
        priceList {
          id
          code
        }
        formatted_wholesale
        formatted_wholesale_promo
        formatted_retail
      }
    }
  }
`;

const deleteValuePriceMutation = gql`
  mutation ($id: ID!) {
    deleteValuePrice(id: $id) {
      price {
        id
        priceList {
          id
          code
        }
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const variables = { id };
  const { loading, data, refetch } = useQuery(articleItemQuery, { variables, fetchPolicy: "cache-and-network" });

  const handleTableChange = () => {};

  const [execDelete] = useMutation(deleteValuePriceMutation, {
    errorPolicy: "none",
    onError: ({ graphQLErrors }) => {
      notification.error({
        placement: "bottomRight",
        message: "Cannot delete this Price",
      });
    },
    onCompleted: ({ deleteValuePrice: { price } }) => {
      notification.success({
        placement: "bottomRight",
        message: `Price "${price.priceList.code}" deleted`,
      });
      refetch();
    },
  });

  const columns = [
    {
      title: "Pricelist",
      render: (value: string, resource: any) => resource.priceList.code,
    },
    {
      title: "Wholesale",
      dataIndex: "formatted_wholesale",
    },
    {
      title: "Wholesale Promo",
      dataIndex: "formatted_wholesale_promo",
    },
    {
      title: "Retail",
      dataIndex: "formatted_retail",
    },
    {
      title: "Actions",
      dataIndex: "id",
      render: (id: string) => (
        <Row justify="end">
          <Space>
            <Tooltip title="Edit" placement="bottom">
              <Button onClick={() => navigate(`${id}/edit`)} icon={<EditOutlined />}></Button>
            </Tooltip>
            <Popconfirm title="Are you sure?" icon={null} onConfirm={() => execDelete({ variables: { id } })}>
              <Tooltip title="Delete" placement="bottom">
                <Button danger icon={<DeleteOutlined />}></Button>
              </Tooltip>
            </Popconfirm>
          </Space>
        </Row>
      ),
    },
  ];

  return (
    <Fragment>
      <PageHeader
        ghost={true}
        title="Prices"
        extra={
          <Button onClick={() => navigate("new")} type="primary">
            <PlusOutlined />
            New
          </Button>
        }
      />
      <Layout.Content className="content">
        <Table
          rowKey="id"
          loading={loading}
          columns={columns}
          dataSource={data?.articleItem?.prices}
          pagination={false}
          onChange={handleTableChange}
        />
      </Layout.Content>
    </Fragment>
  );
};
